import { render, staticRenderFns } from "./SectionProject.vue?vue&type=template&id=016b6f9c"
import script from "./SectionProject.vue?vue&type=script&lang=js"
export * from "./SectionProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports